import {
  CreateRoleReq,
  CreateRoleResp,
  DeleteRoleReq,
  GetAgentPermissionsReq,
  GetPermissionsResp,
  InitRoleReq,
  ListRoleReq,
  ListRoleResp,
  RefreshAgentRoleReq,
  UpdateRoleReq,
} from '@/interfaces/role';
import request from '@/utils/request';

/**
 * 获取客服权限
 */
export const getAgentPermissions = (data: GetAgentPermissionsReq) => {
  return request<GetPermissionsResp>({
    url: '/v1/role/permission/agent',
    method: 'POST',
    data,
  });
};

/**
 * 获取所有权限
 */
export const getAllPermissions = (data: GetAgentPermissionsReq) => {
  return request<GetPermissionsResp>({
    url: '/v1/role/permission/all',
    method: 'POST',
    data,
  });
};

/**
 * 创建角色
 */
export const createRole = (data: CreateRoleReq) => {
  return request<CreateRoleResp>({
    url: '/v1/role/role/create',
    method: 'POST',
    data,
  });
};

/**
 * 删除角色
 */
export const deleteRole = (data: DeleteRoleReq) => {
  return request<boolean>({
    url: '/v1/role/role/delete',
    method: 'DELETE',
    data,
  });
};

/**
 * 角色列表
 */
export const getListRoles = (data: ListRoleReq) => {
  return request<ListRoleResp[]>({
    url: '/v1/role/role/list',
    method: 'POST',
    data,
  });
};

/**
 * 更新角色
 */
export const updateRole = (data: UpdateRoleReq) => {
  return request<boolean>({
    url: '/v1/role/role/update',
    method: 'PUT',
    data,
  });
};

/**
 * 刷新客服角色关联表
 */
export const refreshAgentRole = (data: RefreshAgentRoleReq) => {
  return request<boolean>({
    url: '/v1/role/agent-role/refresh',
    method: 'POST',
    data,
  });
};

/**
 * 初始化企业角色
 */
export const initRole = (data: InitRoleReq) => {
  return request<boolean>({
    url: '/v1/role/role/init',
    method: 'POST',
    data,
  });
};
